import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mt-3" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "float-start me-3 pt-1" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Log systemu")
], -1)
const _hoisted_4 = { class: "float-start" }
const _hoisted_5 = {
  key: 0,
  class: "las la-sort-down"
}
const _hoisted_6 = {
  key: 1,
  class: "las la-sort-up"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = {
  class: "collapse",
  id: "filters"
}
const _hoisted_12 = { class: "card mt-3" }
const _hoisted_13 = { class: "card-body pb-2" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-md-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, "Użytkownik:", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "-- wszyscy --", -1)
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "col-md-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", null, "Zdarzenie:", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "-- wszystkie --", -1)
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "col-md-2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", null, "Znajdź w opisie", -1)
const _hoisted_25 = { class: "col-md-2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", null, "Od:", -1)
const _hoisted_27 = { class: "col-md-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", null, "Do:", -1)
const _hoisted_29 = { class: "col-md-1 text-end" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", null, " ", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "las la-filter" }, null, -1)
const _hoisted_32 = { class: "col-md-1" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", null, " ", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "las la-ban" }, null, -1)
const _hoisted_35 = {
  key: 0,
  class: "row"
}
const _hoisted_36 = { class: "col-md-12" }
const _hoisted_37 = { class: "table table-hover" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Użytkownik"),
    /*#__PURE__*/_createElementVNode("th", null, "Data"),
    /*#__PURE__*/_createElementVNode("th", null, "Zdarzenie"),
    /*#__PURE__*/_createElementVNode("th", null, "Opis")
  ])
], -1)
const _hoisted_39 = { key: 1 }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "mt-5 mb-5 text-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "las la-frown big-glyph" }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Nie znaleziono żadnych elementów pasujących do bieżących filtrów")
  ])
], -1)
const _hoisted_41 = [
  _hoisted_40
]

import { useStore } from "@/store";
    import { computed, ref } from "vue";
    import { ActionTypes } from "@/store/speedprint/action-types";
    import { LogFilters } from "../store/speedprint/models/logFilters";
    import Paging from "@/widgets/Paging.vue";

    // import common logic
    import * as pagingFn from '@/store/commonFunctions/paging';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Log',
  setup(__props) {

    const store = useStore();

    const filters_LOG = ref(new LogFilters());
    const list_LOG = computed(() => store.state.speedprint.log);
    const users = computed(() => store.state.speedprint.users);
    const logEvents = computed(() => store.state.speedprint.logEvents);
    const loadingList = ref(false);
    const showFilters = ref(false);

    const reloadList = async (clearFilters=false) => {
        loadingList.value = true;
        if(clearFilters) filters_LOG.value = new LogFilters();
        await store.dispatch(ActionTypes.GET_LOG, {filters: filters_LOG.value});
        loadingList.value = false;
    }

    // Paging 
    const goToPage = (page: number) => { pagingFn.goToPage(page,filters_LOG.value.pagination); reloadList(); };
    const setItemsPerPage = (itemsPerPage: number) => { pagingFn.setItemsPerPage(itemsPerPage,filters_LOG.value.pagination); reloadList(); };

    reloadList();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-sm btn-outline-secondary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showFilters.value = !showFilters.value)),
            "data-bs-toggle": "collapse",
            "data-bs-target": "#filters",
            "aria-expanded": "false",
            "aria-controls": "filters"
          }, [
            (!showFilters.value)
              ? (_openBlock(), _createElementBlock("i", _hoisted_5))
              : _createCommentVNode("", true),
            (showFilters.value)
              ? (_openBlock(), _createElementBlock("i", _hoisted_6))
              : _createCommentVNode("", true),
            _createTextVNode("   "),
            (!showFilters.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Pokaż"))
              : _createCommentVNode("", true),
            (showFilters.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Ukryj"))
              : _createCommentVNode("", true),
            _createTextVNode(" filtry ")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters_LOG.value.forUser) = $event)),
                    class: "form-select form-select-sm"
                  }, [
                    _hoisted_17,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: user.id,
                        value: user.id
                      }, _toDisplayString(user.name), 9, _hoisted_18))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, filters_LOG.value.forUser]
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters_LOG.value.logEvent) = $event)),
                    class: "form-select form-select-sm"
                  }, [
                    _hoisted_21,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logEvents.value, (evt) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: evt,
                        value: evt
                      }, _toDisplayString(evt), 9, _hoisted_22))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, filters_LOG.value.logEvent]
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters_LOG.value.searchPhrase) = $event))
                  }, null, 512), [
                    [_vModelText, filters_LOG.value.searchPhrase]
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters_LOG.value.dateFrom) = $event))
                  }, null, 512), [
                    [_vModelText, filters_LOG.value.dateFrom]
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters_LOG.value.dateTo) = $event))
                  }, null, 512), [
                    [_vModelText, filters_LOG.value.dateTo]
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-primary",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (reloadList()))
                    }, [
                      _hoisted_31,
                      _createTextVNode(" Filtruj ")
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-secondary",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (reloadList(true)))
                    }, [
                      _hoisted_34,
                      _createTextVNode(" Wyczyść ")
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    (list_LOG.value && list_LOG.value.items.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            (!loadingList.value)
              ? (_openBlock(), _createBlock(Paging, {
                  key: 0,
                  pagingData: list_LOG.value.pagination,
                  padding: true,
                  onGoToPage: goToPage,
                  onSetItemsPerPage: setItemsPerPage
                }, null, 8, ["pagingData"]))
              : _createCommentVNode("", true),
            _createElementVNode("table", _hoisted_37, [
              _hoisted_38,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list_LOG.value.items, (log) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: log.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(log.userName), 1),
                    _createElementVNode("td", null, _toDisplayString(log.date), 1),
                    _createElementVNode("td", null, _toDisplayString(log.event), 1),
                    _createElementVNode("td", null, _toDisplayString(log.description), 1)
                  ]))
                }), 128))
              ])
            ]),
            (!loadingList.value)
              ? (_openBlock(), _createBlock(Paging, {
                  key: 1,
                  pagingData: list_LOG.value.pagination,
                  padding: true,
                  onGoToPage: goToPage,
                  onSetItemsPerPage: setItemsPerPage
                }, null, 8, ["pagingData"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (list_LOG.value && list_LOG.value.items.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_41))
      : _createCommentVNode("", true)
  ], 64))
}
}

})